import React from 'react';
const Title = (props) => {
    const { title, subtitle } = props;
    return (React.createElement("div", { className: 'title' },
        React.createElement("div", { className: 'subtitle' },
            React.createElement("hr", null),
            React.createElement("p", { className: 'alt' }, subtitle),
            React.createElement("hr", null)),
        title && React.createElement("h2", null, title)));
};
export default Title;
